import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/styles.css";
import apiClient from "../api/apiClient";

export default function Dashboard() {
  const [counts, setCounts] = useState({
    users: 0,
    drivers: 0,
    rides: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    const fetchCounts = async () => {
      try {
        const res = await apiClient.get("/admin/counts", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setCounts(res.data);
      } catch {
        localStorage.removeItem("token");
        navigate("/login");
      }
    };

    fetchCounts();
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="analytics-dashboard">
      <div className="analytics-topbar">
        <div>
          <p className="small-label">Zarkit Admin</p>
          <h1>Analytics Dashboard</h1>
          <p className="dashboard-desc">
            Track users, drivers, trips and platform activity.
          </p>
        </div>

        <button className="logout-btn" onClick={logout}>
          Logout
        </button>
      </div>

      <div className="stats analytics-stats">
        <div className="analytics-card">
          <span className="card-icon">U</span>
          <p>Total Users</p>
          <h2>{counts.users}</h2>
          <small>Registered customers</small>
        </div>

        <div className="analytics-card">
          <span className="card-icon">D</span>
          <p>Total Drivers</p>
          <h2>{counts.drivers}</h2>
          <small>Verified delivery partners</small>
        </div>

        <div className="analytics-card">
          <span className="card-icon">T</span>
          <p>All Trips</p>
          <h2>{counts.rides}</h2>
          <small>Completed and active rides</small>
        </div>

        <div className="analytics-card danger-card">
          <span className="card-icon">!</span>
          <p>Issues</p>
          <h2>0</h2>
          <small>Pending complaints</small>
        </div>
      </div>

      <div className="analytics-grid">
        <div className="chart-panel">
          <div className="panel-head">
            <h3>Trip Overview</h3>
            <span>This Week</span>
          </div>

          <div className="bar-chart">
            <div style={{ height: "45%" }}></div>
            <div style={{ height: "70%" }}></div>
            <div style={{ height: "55%" }}></div>
            <div style={{ height: "85%" }}></div>
            <div style={{ height: "60%" }}></div>
            <div style={{ height: "95%" }}></div>
            <div style={{ height: "75%" }}></div>
          </div>

          <div className="chart-days">
            <span>Mon</span>
            <span>Tue</span>
            <span>Wed</span>
            <span>Thu</span>
            <span>Fri</span>
            <span>Sat</span>
            <span>Sun</span>
          </div>
        </div>

        <div className="activity-panel">
          <div className="panel-head">
            <h3>Quick Status</h3>
            <span>Live</span>
          </div>

          <div className="status-list">
            <div>
              <strong>Active Drivers</strong>
              <span>{counts.drivers}</span>
            </div>

            <div>
              <strong>Total Customers</strong>
              <span>{counts.users}</span>
            </div>

            <div>
              <strong>Total Bookings</strong>
              <span>{counts.rides}</span>
            </div>

            <div>
              <strong>System Health</strong>
              <span className="green">Good</span>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-panel modern-panel">
        <div>
          <h3>Operations Control Area</h3>
          <p>Live location, security and delivery tracking area.</p>
        </div>
      </div>
    </div>
  );
}
